<template>
    <div class="bsdc:bg-1-1 bsdc:py-10 bsdc:sm:py-20 bsdc:px-5 bsdc:sm:px-[46px] bsdc:lg:px-12">
        <div class="bsdc:mx-auto max-w-large bsdc:text-center bsdc:space-y-6 bsdc:sm:space-y-8">
            <div class="bsdc:space-y-4">
                <p class="bsdc:subtitle bsdc:text-white/60 bsdc:tracking-widest">
                    {{ subtitle }}
                </p>
                <h2
                    class="bsdc:heading bsdc:text-[1.5rem] bsdc:sm:text-[2rem] bsdc:lg:text-[2.5rem] bsdc:text-white bsdc:font-light">
                    {{ title }}
                </h2>
            </div>

            <button
                v-if="videoImageUrl || videoText || videoEmbed"
                class="bsdc:bg-white/10 bsdc:border bsdc:border-white/10 bsdc:rounded-lg bsdc:overflow-hidden bsdc:flex bsdc:flex-col bsdc:sm:flex-row bsdc:gap-0 bsdc:max-w-[555px] bsdc:mx-auto"
                data-modal-open="configurator-video"
            >
                <div
                    v-if="videoImageUrl"
                    class="bsdc:w-full bsdc:sm:w-[39.63963963963964%] bsdc:shrink-0 bsdc:p-2.5"
                >
                    <img
                        :src="videoImageUrl"
                        alt=""
                        class="bsdc:w-full bsdc:h-full bsdc:object-cover bsdc:rounded-md"
                    />
                </div>

                <div
                    v-if="videoText || videoEmbed"
                    class="bsdc:flex bsdc:flex-col bsdc:justify-center bsdc:p-5 bsdc:pl-2.5 bsdc:text-left"
                >
                    <p
                        v-if="videoText"
                        class="bsdc:text-white bsdc:text-base bsdc:leading-relaxed bsdc:mb-4"
                    >
                        {{ videoText }}
                    </p>

                    <span
                        v-if="videoEmbed"
                        class="bsdc:text-white bsdc:text-base bsdc:inline-flex bsdc:items-center bsdc:uppercase bsdc:text-[13px] bsdc:font-medium bsdc:tracking-wide"
                    >
                        <PlayIcon class="bsdc:w-4 bsdc:h-3" />
                        <span>Play Video</span>
                    </span>
                </div>
            </button>

            <p
                v-if="conciergeText || conciergeLink"
                class="bsdc:text-white bsdc:text-base bsdc:text-center bsdc:flex bsdc:items-center bsdc:justify-center bsdc:gap-1"
            >
                <span
                    v-if="conciergeText"
                    class="bsdc:font-bold"
                >{{ conciergeText }}</span>
                <a
                    v-if="conciergeLink"
                    :href="conciergeLink"
                    class="bsdc:underline bsdc:hover:decoration-transparent bsdc:transition-colors"
                >
                    {{ conciergeLinkText }}
                </a>
            </p>
        </div>
    </div>

    <div
        data-modal="configurator-video"
        class="modal modal-video"
    >
        <div class="modal-outer">
            <div class="modal-inner">
                <div class="modal-content">
                    <div
                        class="video"
                        v-html="decodedVideoEmbed"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    import PlayIcon from '@img/icons/play.svg';

    const subtitle = BSDC.defaultSubtitle || null;
    const title = BSDC.defaultTitle || null;
    const videoImageUrl = BSDC.videoImageUrl || null;
    const videoText = BSDC.videoText || null;
    const videoEmbed = BSDC.videoEmbed || null;
    const conciergeText = BSDC.conciergeText || null;
    const conciergeLink = BSDC.conciergeLink || null;
    const conciergeLinkText = BSDC.conciergeLinkText || null;

    const decodedVideoEmbed = computed(() => {
        if (!videoEmbed) {
            return null;
        }

        const textarea = document.createElement('textarea');
        textarea.innerHTML = videoEmbed;

        return textarea.value;
    });
</script>
